import UiDashboardForm from 'global/pageItem/modification/dataModifications/UiDashboardForm'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares '
import TransitionWrapper from 'global/wrappers/TransitionWrapper'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import WrapperVertCols from 'global/wrappers/WrapperVertCols'
import { _sportsFormProps, SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import React, { useContext, useState } from 'react'
import { _sdm } from './SportsDashboard'
import { SportsDistrictContext } from 'projectSpecific/sports/cnr/contexts/SportsDistrictContext'
import _ from 'lodash'
import { Form } from 'semantic-ui-react'
import { SelectedTicketStatus } from 'projectSpecific/ticketing/components/SelectedTicketStatus'
import UiSaveButtons from 'global/components/buttons/UiSaveButtons'
import SportFormProps from 'projectSpecific/sports/create/SportFormProps'

const _teamDashboardTypes = {
  access: 'access',
  gls: 'gls',
}

export const TeamsDashboard = () => {

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { sportsAccess_teams, gls_teams, teams_info } = sportsSeason_state ?? {}
  const { teams } = teams_info ?? {}
  const { teams: access_teams } = sportsAccess_teams ?? {}

  const [currentTeam, setCurrentTeam] = useState()
  const [currentType, setCurrentType] = useState()

  const [teamsAccess, setTeamsAccess] = useState(access_teams)
  const [teamAccess, setTeamAccess] = useState()

  const [teamsGls, setTeamsGls] = useState(gls_teams)
  const [teamGls, setTeamGls] = useState()

  const [currentAccessItem, setCurrentAccessItem] = useState()
  const [formData, setFormData] = useState(_sportsFormProps[_sdm.sports.glsTeam])

  console.log('teamsGls', teamsGls)

  const handelSelect_team = (team) => {
    setCurrentTeam(team)
    setCurrentType()
    setCurrentAccessItem()
  }
  const handelSelect_type = (type) => {
    setCurrentType(type)
    switch (type) {
      case _teamDashboardTypes.access:
        const access_team = teamsAccess?.[currentTeam?._itemKey]
        setTeamAccess(access_team)
        break;
      case _teamDashboardTypes.gls:
        const _formData = _.clone(formData)
        console.log('_formData', _formData)
        const gls_team = teamsGls?.[currentTeam?._itemKey]
        setTeamGls(gls_team)
      // setFormData(gls_team)
    }
  }

  const wrapper_teams = () => <Wrapper
    header={'Teams'}
    content={<TransitionWrapper>
      <ItemMenuSquares
        menuItems={_.sortBy(teams, 'name')}
        onClick={handelSelect_team}
        activeItem={currentTeam?._itemKey}
        imsType={_imsTypes.inline}
        iconItem={'users'}
      />
    </TransitionWrapper>}
  ></Wrapper>

  const wrapper_teamTypes = () => <Wrapper
    header={`${currentTeam?.name || 'Team'}`}
    content={<TransitionWrapper>
      <ItemMenuSquares
        menuItems={_teamDashboardTypes}
        onClick={handelSelect_type}
        activeItem={currentType}
        imsType={_imsTypes.inline}
        icon={'users'}
      />
    </TransitionWrapper>}
  ></Wrapper>

  const handleChange = (e, i) => { setCurrentAccessItem(i.value) }

  const handleAddToList = () => {
    const _teamAccess = teamAccess ? _.cloneDeep(teamAccess) : []
    const _teamsAccess = teamsAccess ? _.cloneDeep(teamsAccess) : []
    _teamAccess.push({
      accessLevel: 'scores',
      name: currentAccessItem
    })
    _teamsAccess[currentTeam._itemKey] = _teamAccess
    setTeamAccess(_teamAccess)
    setTeamsAccess(_teamsAccess)
  }

  const handle_update = () => {
    switch (currentType) {
      case _teamDashboardTypes.access:
        console.log('teamsAccess', teamsAccess)
        break;
      case _teamDashboardTypes.gls:
        break;
    }
  }

  const item_add = () => <Form.Input
    fluid
    value={currentAccessItem}
    onChange={handleChange}
    action={{ disabled: !currentAccessItem, color: 'blue', icon: 'check', onClick: () => { handleAddToList() } }}
  />

  const footer_item = () => {
    switch (currentType) {
      case _teamDashboardTypes.access:
        return <UiSaveButtons
          save={{
            oc: handle_update,
            caption: 'Save Access'
          }}
        />
      case _teamDashboardTypes.gls:
        return <UiSaveButtons
          save={{
            oc: handle_update,
            caption: 'Save GLS'
          }}
        />
    }
  }

  const handleFormChange = () => {

  }

  const formElements = () => {
    const inputs = []
    if (formData) {
      return <SportFormProps formData={formData} handleFormChange={handleFormChange} />
    }
    return inputs
  }

  const content_form = () => {
    const form = <Form>
      {formElements()}
    </Form>
    return form
  }

  const content_item = () => {
    switch (currentType) {
      case _teamDashboardTypes.access:
        if (teamAccess) {
          _.forEach(teamAccess, t => {
            t.caption = t.name
          })
        }
        return <Wrapper
          header={item_add()}
          content={<ItemMenuSquares menuItems={teamAccess} imsType={_imsTypes.inline} keepCaption={true} />}
          wrapperType={wrapperTypes.padded}
          footer={footer_item()}
        >
        </Wrapper>
        return
      case _teamDashboardTypes.gls:
        return <Wrapper
          content={content_form()}
          wrapperType={wrapperTypes.padded}
          footer={footer_item()}
        >
        </Wrapper>
    }
  }

  const wrapper_teamData = () => <Wrapper
    header={currentType ? _.startCase(currentType) : 'Selected Type'}
    content={<TransitionWrapper>
      {content_item()}
    </TransitionWrapper>}
  ></Wrapper>

  const content = () => <WrapperVertCols mvc={'1-1-2'}  >
    {wrapper_teams()}
    {wrapper_teamTypes()}
    {wrapper_teamData()}
  </WrapperVertCols>

  return (
    content()
  )
}
